import { createTypes, createAction } from "lib/action";

const LOAD_PRICELIST = createTypes("pricelist", "load");
const SHOW_PRICELIST = createTypes("pricelist", "show");
const CREATE_PRICELIST = createTypes("pricelist", "create");
const UPDATE_PRICELIST = createTypes("pricelist", "update");
const DELETE_PRICELIST = createTypes("pricelist", "delete");
const IMPORT_PRICELIST = createTypes("pricelist", "import");
const EXPORT_PRICELIST = createTypes("pricelist", "export");
const LOAD_PRICELIST_PRODUCTS = createTypes("pricelist", "loadProducts");

const loadPricelists = {
  request: (params, token) => createAction(LOAD_PRICELIST.REQUEST, { params, token }),
  success: data => createAction(LOAD_PRICELIST.SUCCESS, { data }),
  failure: err => createAction(LOAD_PRICELIST.FAILURE, { err }),
};

const showPricelist = {
  request: (id, token) => createAction(SHOW_PRICELIST.REQUEST, { id, token }),
  success: data => createAction(SHOW_PRICELIST.SUCCESS, { data }),
  failure: err => createAction(SHOW_PRICELIST.FAILURE, { err }),
};

const createPricelist = {
  request: (params, token) => createAction(CREATE_PRICELIST.REQUEST, { params, token }),
  success: data => createAction(CREATE_PRICELIST.SUCCESS, { data }),
  failure: err => createAction(CREATE_PRICELIST.FAILURE, { err }),
};

const updatePricelist = {
  request: (params, id, token) => createAction(UPDATE_PRICELIST.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_PRICELIST.SUCCESS, { data }),
  failure: err => createAction(UPDATE_PRICELIST.FAILURE, { err }),
};

const deletePricelist = {
  request: (id, token) => createAction(DELETE_PRICELIST.REQUEST, { id, token }),
  success: id => createAction(DELETE_PRICELIST.SUCCESS,  { id } ),
  failure: err => createAction(DELETE_PRICELIST.FAILURE, { err }),
};

const importPricelist = {
    request: (file, company_id, user_id, token) => createAction(IMPORT_PRICELIST.REQUEST, { file, company_id, user_id, token }),
    success: data => createAction(IMPORT_PRICELIST.SUCCESS, { data }),
    failure: err => createAction(IMPORT_PRICELIST.FAILURE, { err }),
}

const exportPricelist = {
    request: (params, token) => createAction(EXPORT_PRICELIST.REQUEST, { params, token }),
    success: data => createAction(EXPORT_PRICELIST.SUCCESS, { data }),
    failure: err => createAction(EXPORT_PRICELIST.FAILURE, { err }),
}

const loadPricelistProducts = {
    request: (params, token) => createAction(LOAD_PRICELIST_PRODUCTS.REQUEST, { params, token }),
    success: data => createAction(LOAD_PRICELIST_PRODUCTS.SUCCESS, { data }),
    failure: err => createAction(LOAD_PRICELIST_PRODUCTS.FAILURE, { err }),
}

export {
  loadPricelists,
  showPricelist,
  createPricelist,
  updatePricelist,
  deletePricelist,
  importPricelist,
  exportPricelist,
  loadPricelistProducts,
  LOAD_PRICELIST,
  SHOW_PRICELIST,
  CREATE_PRICELIST,
  UPDATE_PRICELIST,
  DELETE_PRICELIST,
  IMPORT_PRICELIST,
  EXPORT_PRICELIST,
  LOAD_PRICELIST_PRODUCTS
};
